import { SVG } from '../SVG'

const EditIcon = ({ style = {}, ...props }) => (
  <SVG
    width='35'
    height='35'
    viewBox='0 0 35 35'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path d='M32.1615 7.76717C32.7389 8.34458 32.7484 9.27778 32.1828 9.86677L18.6139 23.9973C18.3386 24.284 17.9608 24.4497 17.5634 24.4581L11.8492 24.5779L11.9694 18.8485C11.9775 18.4602 12.136 18.0902 12.4114 17.8163L26.2931 4.01397C26.8794 3.43105 27.8268 3.43241 28.4114 4.01701L32.1615 7.76717Z' />
    <path
      opacity='0.3'
      d='M18.8781 2.1875C19.7238 2.1875 20.4094 2.87306 20.4094 3.71875C20.4094 4.56444 19.7238 5.25 18.8781 5.25H8.3125C6.62113 5.25 5.25 6.62113 5.25 8.3125V26.6875C5.25 28.3789 6.62113 29.75 8.3125 29.75H26.6875C28.3789 29.75 29.75 28.3789 29.75 26.6875V19.0312C29.75 18.1856 30.4356 17.5 31.2812 17.5C32.1269 17.5 32.8125 18.1856 32.8125 19.0312V26.6875C32.8125 30.0702 30.0702 32.8125 26.6875 32.8125H8.3125C4.92976 32.8125 2.1875 30.0702 2.1875 26.6875V8.3125C2.1875 4.92976 4.92976 2.1875 8.3125 2.1875H18.8781Z'
    />
  </SVG>
)

export default EditIcon
